import React from "react";
import {
  Box,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
  Stack,
} from "@mui/material";
import { Twitter, Facebook, Instagram, LinkedIn } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import Fbacground from "../images/bgtruck.jpg";
import Logo from "../images/logo.png";

const Footer = () => {
  return (
    <Box
      sx={{
        position: "relative",
        color: "#fff",
        backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.85), rgba(0,0,0,0.9)), url(${Fbacground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        pt: { xs: "3rem", md: "4rem" },
        pb: "2rem",
        px: { xs: "1.5rem", sm: "3rem" },
      }}
    >
      {/* Top Content */}
      <Grid container spacing={4} justifyContent="space-between">
        {/* Logo + Social Icons */}
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          textAlign={{ xs: "center", md: "left" }}
        >
          {/* Clickable Logo */}
          <Box sx={{ mb: "1rem" }}>
            <Link
              component={RouterLink}
              to="/"
              sx={{ display: "inline-block" }}
            >
              <Box
                component="img"
                src={Logo}
                alt="Mangalmurti Transport"
                sx={{
                  height: "3.75rem", // 60px
                  width: "auto",
                  display: "block",
                  mx: { xs: "auto", md: 0 },
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "scale(1.05)" },
                }}
              />
            </Link>
          </Box>

          {/* Social Icons */}
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              fontSize: "1.25rem",
              color: "#ff6600",
              mb: "1rem",
            }}
          >
            Our Social Media
          </Typography>
          <Stack
            direction="row"
            spacing={1.5}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            {[Twitter, Facebook, Instagram, LinkedIn].map((Icon, index) => (
              <IconButton
                key={index}
                sx={{
                  color: "#fff",
                  bgcolor: "rgba(255,255,255,0.08)",
                  "&:hover": {
                    bgcolor: "#ff6600",
                    color: "#fff",
                    transform: "scale(1.1)",
                  },
                  transition: "all 0.3s ease",
                }}
                size="small"
              >
                <Icon fontSize="small" />
              </IconButton>
            ))}
          </Stack>
        </Grid>

        {/* Belapur Location */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{ fontSize: "1.25rem", color: "#ff6600", mb: "1rem" }}
          >
            Belapur Office
          </Typography>
          <Typography
            variant="body2"
            sx={{ lineHeight: 1.8, fontSize: "0.95rem" }}
          >
            Shop No. 1, Suraj Apartment, <br />
            Plot No. B-125, Sector-20, CBD Belapur, <br />
            Navi Mumbai 400614
          </Typography>
          <Typography variant="body2" sx={{ mt: "1rem", fontSize: "0.95rem" }}>
            <strong>Phone:</strong> +91 9987174246 <br />
            <strong>Email:</strong> mangalmurti.transport@gmail.com
          </Typography>
        </Grid>

        {/* Useful Links */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{ fontSize: "1.25rem", color: "#ff6600", mb: "1rem" }}
          >
            Useful Links
          </Typography>
          <Stack spacing={0.5}>
            {[
              { name: "Home", path: "/" },
              { name: "About Us", path: "/about" },
              { name: "Services", path: "/services" },
              { name: "Contact", path: "/contact" },
            ].map((link, idx) => (
              <Link
                key={idx}
                component={RouterLink}
                to={link.path}
                underline="hover"
                color="inherit"
                sx={{
                  fontSize: "0.95rem",
                  transition: "all 0.3s ease",
                  "&:hover": { color: "#ff6600", pl: "0.25rem" },
                }}
              >
                {link.name}
              </Link>
            ))}
          </Stack>
        </Grid>

        {/* Map Location */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{ fontSize: "1.25rem", color: "#ff6600", mb: "1rem" }}
          >
            Find Us On
          </Typography>
          <Box
            sx={{
              width: "100%",
              height: "12.5rem", // 200px
              borderRadius: "0.5rem",
              overflow: "hidden",
              boxShadow: 4,
              border: "0.125rem solid #ff6600",
              "& iframe": {
                filter: "grayscale(40%)",
                transition: "0.3s ease",
                "&:hover": { filter: "grayscale(0%)" },
              },
            }}
          >
            <iframe
              title="Mangalmurti Location"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              src="https://www.google.com/maps?q=19.01494,73.0295&output=embed"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </Box>
        </Grid>
      </Grid>

      {/* Bottom Divider */}
      <Divider sx={{ my: "2rem", borderColor: "rgba(255,255,255,0.1)" }} />

      {/* Copyright */}
      <Typography
        variant="body2"
        align="center"
        sx={{
          fontSize: "0.85rem",
          color: "rgba(255,255,255,0.6)",
        }}
      >
        © {new Date().getFullYear()}{" "}
        <strong style={{ color: "blue" }}>Umbrella Web FX</strong>. All
        rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
